import React, { useCallback, useState } from 'react';
// import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import type { UploadProps } from 'antd';
import { Upload, message } from 'antd';
import { ConBrandWebController } from '@/services/swagger/ConBrandWebController';
import ServerSideFetch from '@/utils/server-side-fetch';
import { isEmail } from '@/constants/regexp';
import { RootState } from '@/models';
import { IS_PROD } from '@/constants/env';
import Layout from '@/layouts';
import Breadcrumb from '@/components/breadcrumb';
import Input from '@/components/input';
import Button from '@/components/button';
import { ConUserTypeExamineWebController } from '@/services/swagger/ConUserTypeExamineWebController';
import WaitingVerify from '../../components/waitingVerify';
import styles from './index.module.scss';

const { Dragger } = Upload;
const controller = new ConUserTypeExamineWebController();
const suffix = ['jpg', 'png', 'jpeg'];
const size = 1;
const getFileNameData = (fileFullName?: string) => {
  if (!fileFullName) return {};
  const fileNameArr = fileFullName.split('.');
  const fileType = fileNameArr[fileNameArr.length - 1];
  fileNameArr.pop();
  let fileName: any = fileNameArr.join('.');
  fileName = fileName.split('/');
  fileName = fileName[fileName.length - 1];
  return { fileType, fileName };
};
const brandController = new ConBrandWebController();
export const getServerSideProps = async ({ params }) => {
  const { data: brandInfo } = await ServerSideFetch(brandController.conBrandWebControllerV1FindUsingGet1, {
    conBrandId: params?.id,
  });
  return { props: { id: params?.id, brandInfo } };
};
export default function CertifiedInvestor({ id }) {
  const dispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.user);
  const [imgCard, setImgCard] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitVerify, setIsSubmitVerify] = useState(false);
  const props: UploadProps = {
    name: 'file',
    accept: '.png, .jpg, .jpeg',
    multiple: false,
    action: `${
      IS_PROD ? 'https://api-next.cbndata.com' : 'https://api-next-staging.cbndata.com'
    }/consumerstation/web/file/upload`,
    headers: {
      Authorization: token,
    },
    itemRender: () => <></>,
    // withCredentials: true,
    beforeUpload: file => {
      if (!token) {
        dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
        return;
      }
      const fileNameData = getFileNameData(file.name);
      const fileType = fileNameData.fileType || '';
      // const isImg = imgSuffix.includes(fileType);

      const fixSuffixList = suffix.map(item => item.toLowerCase());
      const isValid = fixSuffixList.includes(fileType.toLowerCase());
      if (!isValid) {
        message.error(`请选择 ${suffix.join('/')} 格式!`);
        return Upload.LIST_IGNORE;
      }
      const isOverly = file.size / 1024 / 1024 > size;
      if (isOverly) {
        message.error(`文件大小需限制在2M以下.`);
        return Upload.LIST_IGNORE;
      }
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        // message.success(`${info.file.name} file uploaded successfully.`);
        if (info.file?.response?.code === 200) {
          setImgCard(info.file?.response?.data?.url);
        }
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  const isComplete = useCallback(() => imgCard && isEmail.test(email), [email, imgCard]);
  const handleSubmit = async () => {
    const { data: res } = await controller.conUserTypeExamineWebControllerV1ExamineBrandUserUsingPost1({
      brandId: id,
      email,
      imgUrl: imgCard,
    });
    if (res?.code == 200) {
      setIsSubmitVerify(true);
    } else {
      message.error(res?.msg);
    }
  };
  // const { slug } = req.query;

  return (
    <Layout
      title="品牌方认证| CBNData品牌数集"
      description="CBNData品牌数集是第一财经商业数据中心（CBNData）旗下一款衡量品牌综合实力的可视化数据工具，基于CBNData沉淀的中国新消费品牌增长力评估模型与数据能力，从品牌赛道潜力、组织能力、经营能力、产品竞争力、营销能力、供应链能力、用户发展能力等7个维度，系统化帮助投资人及品牌创始人衡量品牌综合实力、评估品牌风险、分析行业竞争格局以及挖掘高增长潜力的新锐品牌。"
      keyword="消费、新消费、中国新消费、品牌、数据、数据库、国货、国潮、增长、风险评估、行业、赛道、竞品、组织、公司、产品、营销、供应链、用户、数据工具、数据可视化，品牌数集、CBNData、CBN、第一财经"
      isShowNavBar
      isFrapMain
    >
      <Breadcrumb
        list={[
          { href: '/brand', title: '品牌库' },
          { href: `/brand/${id}`, title: '品牌库详情' },
          { title: '品牌方认证' },
        ]}
      />
      <div className={styles.certifiedInvestor}>
        {isSubmitVerify ? (
          <WaitingVerify />
        ) : (
          <div className={styles.certifiedInvestor__content}>
            <img src="//assets-oss.cbndata.com/cbndata-consume-brand/FgnmEPJ2oCE3Sr3oyKOC-TRpXHoB.png" />
            <div className={styles.title}>品牌方认证</div>
            <div className={styles.subtitle}>
              如果你是该品牌创始人/高管，欢迎认领品牌，认领品牌后可获得编辑品牌信息等权限
            </div>
            <div className={styles.upload}>
              {imgCard ? (
                <img src={imgCard} className={styles.imgCard} />
              ) : (
                <Dragger {...props}>
                  <img src="//assets-oss.cbndata.com/cbndata-consume-brand/Fi--kp9w6Lo6gz0Vn-NiWc03aTEl.png" />
                  <div className={styles.upload__title}>
                    将名片拖到此处，或<span className={styles.emphasize}>点击上传</span>
                  </div>
                </Dragger>
              )}
            </div>
            <Input
              placeholder="请留下您的邮箱"
              className={styles.email}
              value={email}
              onChange={val => setEmail(val)}
            />
            <div className={styles.notice}>*请务必确保上传本人名片，名片上的公司名称与所认领的品牌一致</div>
            <div className={styles.notice}>
              *提交后请前往邮箱验证，通过后我们会在3个工作日内进行审核，并通过邮件方式沟通审核进度
            </div>
            <div className={styles.notice}>*图片大小限定为20M以内的PNG、JPG、JPEG格式</div>
            <div className={styles.otherNotice}>如有其他认证问题请联系客服，客服邮箱：cbndatacs@yinfinity.com</div>
            <Button type={isComplete() ? 'normal' : 'shadow'} disabled={!isComplete()} onClick={handleSubmit}>
              提交
            </Button>
          </div>
        )}
      </div>
    </Layout>
  );
}
